import { createSelector } from 'reselect'

import { LandingOffering } from 'partner360/models/landing/LandingOffering'

import { selectLandingState } from './selectLandingState'

export const selectLandingProcessesByOffering = createSelector(
  [selectLandingState],
  ({ selectedPlanning, selectedOffering, selectedCategory, processedPlannings }) => {
    if (selectedOffering === LandingOffering.Total) {
      return processedPlannings.filter(
        (el) => el.category === selectedCategory && el.planningId === selectedPlanning.PlanningId
      )
    }

    return processedPlannings.filter(
      (el) =>
        el.category === selectedCategory &&
        el.planningId === selectedPlanning.PlanningId &&
        el.offering === selectedOffering &&
        el.isOfferingActive
    )
  }
)
